module.exports = __webpack_public_path__ + "static/investing-community-mobile.ee628f9b.webp";